import React from 'react';

function EducationCard({ item }) {
    const { course, institution, startYear, endYear, detail } = item;
    const period = [startYear, endYear].filter(Boolean).join(' – ');

    return (
        <>
            <p className='education__period'>{period}</p>
            <div>
                <h3>{course}</h3>
                <p className='education__institution'>{institution}</p>
                {detail && <p className='education__detail'>{detail}</p>}
            </div>
        </>
    );
}

export default EducationCard;
